// @core/api/endpoints/analytics/create_report_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateReportScheduleRequest,
  ReportScheduleResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Create report schedule
 * Creates an automated report generation schedule. Reports are generated at specified intervals and delivered to recipients.
 */
export async function CreateReportSchedule(
  data: CreateReportScheduleRequest,
  options?: RequestOptions
): Promise<ReportScheduleResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/report-schedules`;
  const requestOptions = options;
  return client.post<ReportScheduleResponse>(requestPath, data, requestOptions);
}
